<template>
  <basic-master
    v-if="hasAddonGkmgPortMaster"
    masterName="船舶"
    insertDataPageName="addon-gkmg-port-master-vessel-insert"
    viewPageName="addon-gkmg-port-master-vessel-view"
    @callDelete="/**callDelete **/"
    @callSearch="callSearch"
    @updateDisplayItems="updateDisplayItems"
    :storedSearchKeyword="storedSearchKeyword"
    :data="data"
    :columns="columns"
    :pagination="true"
    :totalPages="totalPages"
    :totalItems="totalItems"
    :currentPage="currentPage"
    :displayItems="displayItems"
    :incrementSearch="false"
    :sortable="false"
    :editable="false"
  >
  </basic-master>
</template>

<script>
import BasicMaster from "../components/BasicMaster";
import { createNamespacedHelpers } from "vuex";
import { VESSEL_MASTER_COL_NAME } from "@/config/const";
const { mapActions, mapGetters, mapState } =
  createNamespacedHelpers("gkmgPortMaster");
const DISPLAY_ROWS_PER_ONE_PAGE = 10;

export default {
  components: {
    BasicMaster,
  },
  data() {
    return {
      totalPages: 0,
      totalItems: 0,
      // refreshData()する直前のlastSearchConditionで、特定のページがセットされていたら、そのページを表示する。
      currentPage: this.$route.params.lastSearchCondition
        ? this.$route.params.lastSearchCondition.page
        : 0,
      displayItems: {
        number: null,
      },
      columns: VESSEL_MASTER_COL_NAME.filter((el) => el.show),
      data: [],
      isDataLoaded: false,
      storedSearchKeyword: "",
      lastSearchCondition: {},
    };
  },
  async created() {
    if (this.hasAddonGkmgPortMaster) {
      await this.getGkmgPortMasterAuth();
    }
    await this.searchVessels();
    this.displayItems = {
      number:
        this.storedMasterSearchCondition.vessel &&
        this.storedMasterSearchCondition.vessel.limit
          ? this.storedMasterSearchCondition.vessel.limit
          : DISPLAY_ROWS_PER_ONE_PAGE,
    };
    this.$nextTick(() => {
      setTimeout(() => {
        this.refreshData(this.$route.params.lastSearchCondition);
      }, 1200); // 300等、あまり早い設定にすると、リフレッシュ時にデータが表示されないので、1200と設定している。
    });
  },
  computed: {
    ...mapGetters(["gkmgPortMasterAuth", "hasAddonGkmgPortMaster"]),
    ...mapState({
      storedMasterSearchCondition: (state) => state.storedMasterSearchCondition,
      vesselsData: (state) => state.vesselsData,
      vesselsDataUpdated: (state) => state.vesselsDataUpdated,
    }),
  },
  beforeDestroy() {
    this.unsubscribeFirestoreOnVesselMaster();
  },
  methods: {
    ...mapActions([
      // "updateVessel",
      // "deleteVessel",
      "searchVessels",
      "setStoredMasterSearchCondition",
      "unsubscribeFirestoreOnVesselMaster",
      "getGkmgPortMasterAuth",
    ]),
    async updateDisplayItems(number) {
      this.displayItems.number = number;
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData();
        }, 300);
      });
    },
    async refreshData(lastSearchCondition) {
      if (lastSearchCondition) {
        this.currentPage = lastSearchCondition.page;
        this.storedSearchKeyword = lastSearchCondition.name
          ? lastSearchCondition.name
          : "";
      }
      const query = {
        limit: this.displayItems.number,
        page: this.currentPage,
      };

      this.setStoredMasterSearchCondition({
        ...this.storedMasterSearchCondition,
        vessel: query,
      }); // ページ表示件数を永続化するため検索条件を保存

      this.data = this.vesselsData
        .slice(
          query.page * this.displayItems.number,
          query.page * this.displayItems.number + this.displayItems.number,
        )
        .map((el) => el.data);

      this.totalItems = this.vesselsData.length;
      this.totalPages =
        Math.floor(this.totalItems / this.displayItems.number) + 1;
    },

    async callSearch(condition) {
      if (Object.prototype.hasOwnProperty.call(condition, "keyword"))
        this.storedSearchKeyword = condition.keyword;
      const query = {
        limit: condition.limit,
        page: condition.page,
        name: this.storedSearchKeyword ? this.storedSearchKeyword : null,
      };

      this.setStoredMasterSearchCondition({
        ...this.storedMasterSearchCondition,
        vessel: query,
      });

      const vesselMasterList = !query.name
        ? this.vesselsData
        : this.vesselsData.filter((el) =>
            String(el.data["name"]).includes(String(query.name)),
          );

      this.totalPages =
        Math.floor(vesselMasterList.length / condition.limit) + 1;
      this.totalItems = vesselMasterList.length;

      this.data = vesselMasterList
        .slice(
          condition.page * condition.limit,
          condition.page * condition.limit + condition.limit,
        )
        .map((el) => el.data);

      this.currentPage = condition.page;
      this.lastSearchCondition = condition;
    },

    // async callDelete(id) {
    //   let payload = {
    //     id: id,
    //   };
    //   this.$vs.loading();
    //   await this.deleteVessel(payload);
    //   this.$vs.notify({
    //     title: "データを削除しました。",
    //     color: "danger",
    //     iconPack: "feather",
    //     icon: "icon-check",
    //     position: "top-center",
    //   });
    //   this.$vs.loading.close();
    //   let condition = {
    //     limit: this.displayItems.number,
    //     page: 0,
    //   };
    //   this.callSearch(condition);
    // },
  },
};
</script>

<style lang="scss" scoped></style>
